import bulmaCollapsible from '@creativebulma/bulma-collapsible';

document.addEventListener('DOMContentLoaded', () => {
    bulmaCollapsible.attach('.is-collapsible:not(.is-vue-collapsible):not(.modal)');

    const $searchModal = document.getElementById('modal-search');

    if (!$searchModal) {
        return;
    }

    const $searchTriggers = document.querySelectorAll('[data-action="collapse"][href="#modal-search"], [data-action="collapse"][data-target="modal-search"]');
    const $searchInput = $searchModal.querySelector('input[type="search"]');

    const openSearchModal = () => {
        $searchModal.classList.add('is-active');
        document.documentElement.classList.add('is-clipped');
        $searchInput?.focus();
    };

    const closeSearchModal = () => {
        $searchModal.classList.remove('is-active');
        document.documentElement.classList.remove('is-clipped');
    };

    $searchTriggers.forEach(($searchTrigger) => {
        $searchTrigger.addEventListener('click', (event) => {
            event.preventDefault();

            if ($searchModal.classList.contains('is-active')) {
                closeSearchModal();
            }
            else {
                openSearchModal();
            }
        });
    });

    $searchModal.addEventListener('click', (event) => {
        if (event.target.classList.contains('modal-background')) {
            closeSearchModal();
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && $searchModal.classList.contains('is-active')) {
            closeSearchModal();
        }
    });
});